import css from './Skeleton.module.css';

/**
 * Скелетон-плейсхолдеры для списков (нативный вид загрузки вместо спиннера).
 * variant: 'card' (каталог), 'order' (список заказов), 'row' (узкие строки).
 */
export function SkeletonList({ count = 6, variant = 'card' }) {
  const items = Array.from({ length: count });
  return (
    <div class={css.list} aria-hidden="true">
      {items.map((_, i) => (
        <SkeletonItem key={i} variant={variant} />
      ))}
    </div>
  );
}

function SkeletonItem({ variant }) {
  if (variant === 'order') {
    return (
      <div class={css.orderCard}>
        <div class={css.lineRow}>
          <span class={`${css.sk} ${css.lineSm}`} />
          <span class={`${css.sk} ${css.pill}`} />
        </div>
        <span class={`${css.sk} ${css.lineLg}`} />
        <span class={`${css.sk} ${css.lineMd}`} />
      </div>
    );
  }
  if (variant === 'row') {
    return <span class={`${css.sk} ${css.row}`} />;
  }
  // card (каталог)
  return (
    <div class={css.card}>
      <span class={`${css.sk} ${css.thumb}`} />
      <div class={css.cardBody}>
        <span class={`${css.sk} ${css.lineLg}`} />
        <span class={`${css.sk} ${css.lineSm}`} />
        <span class={`${css.sk} ${css.lineMd}`} />
      </div>
    </div>
  );
}
